import { MapMode, MapboxLayer, useHazardsStore, useMapStore } from '@/features';

export const updateFireDangerRatings = () => {
  const hazardsStore = useHazardsStore();

  if (hazardsStore.mapMode !== MapMode.FireDanger) {
    return;
  }

  const map = useMapStore();

  const fdrScheme =
    hazardsStore.hazards.fireDangerRatings?.map((fdr) => {
      const fdrEntitySubType = fdr.pointFeature?.properties?.schemes?.[hazardsStore.selectedDateIndex]?.entitySubType;
      return {
        icons: [fdr.title, `ew-${fdrEntitySubType?.split('_').join('-')}`],
        fillColors: [fdr.title, fdr.polygonFeatures?.[0].properties?.schemes?.[hazardsStore.selectedDateIndex]?.fill],
      };
    }) ?? {};

  const fdrIconMap = Object.fromEntries(fdrScheme.map((fdr) => fdr.icons));
  const fdrFillColorMap = Object.fromEntries(fdrScheme.map((fdr) => fdr.fillColors));

  if (!map.mapbox?.getLayer(MapboxLayer.fireDangerRatingsMarkersLayer)) return;
  map.mapbox?.setLayoutProperty(MapboxLayer.fireDangerRatingsMarkersLayer, 'icon-image', [
    'case',
    ['has', ['get', 'name'], ['literal', fdrIconMap]],
    ['get', ['get', 'name'], ['literal', fdrIconMap]],
    'ew-fdr-no-rating',
  ]);

  if (!map.mapbox?.getLayer(MapboxLayer.fireDangerRatingsPolygonsLayer)) return;
  map.mapbox?.setPaintProperty(MapboxLayer.fireDangerRatingsPolygonsLayer, 'fill-color', [
    'case',
    ['has', ['get', 'DIST_NAME'], ['literal', fdrFillColorMap]],
    ['get', ['get', 'DIST_NAME'], ['literal', fdrFillColorMap]],
    'rgba(0, 0, 0, 0)',
  ]);
};
